import { sort } from 'fp-ts/lib/Array'
import { contramap, getSemigroup, Ord, ordNumber } from 'fp-ts/lib/Ord'
import { fold } from 'fp-ts/lib/Semigroup'

import { DateTime } from '@espoon-voltti/ts-libs/lib/time'

import { GrantApp } from '../../domain'

type AppState = GrantApp['state']
const ordState: Ord<AppState> = contramap((x: AppState) => stateOrder[x])(
  ordNumber
)
const ordAppByState: Ord<GrantApp> = contramap((x: GrantApp) => x.state)(
  ordState
)
const ordAppByTimestamp: Ord<GrantApp> = contramap((x: GrantApp) =>
  appTimestamp(x)
)(DateTime.ordDesc)
const ordApp = fold(getSemigroup<GrantApp>())(ordAppByState, [
  ordAppByTimestamp
])
export const sortApps = sort(ordApp)

const stateOrder: Record<AppState, number> = {
  SIGNING: 0,
  DRAFT: 1,
  SENT: 2,
  REVIEW: 3,
  REJECTED: 4,
  PRE_REPORT: 4,
  PAYMENT_WAIT: 5,
  POST_REPORT: 6,
  PAID: 6,
  RECOVERY: 6,
  RECOVERED: 7
}

const appTimestamp = (x: GrantApp): DateTime => {
  switch (x.state) {
    case 'DRAFT':
      return x.modifiedAt
    case 'SIGNING':
      return x.signing.sentForSigningAt!
    case 'SENT':
      return x.sent.sentAt
    case 'REVIEW':
      return x.review.reviewStartedAt
    case 'REJECTED':
    case 'PRE_REPORT':
    case 'PAYMENT_WAIT':
    case 'POST_REPORT':
    case 'PAID':
    case 'RECOVERY':
    case 'RECOVERED':
      return x.decidedAt
    default:
      const _: never = x
      return _
  }
}
